import { is3pProductKey } from "../../constants/products";
import { SMARTLINKS_CONNECTOR_SOURCE, type ThirdPartyConfigsBootstrap } from "../../constants/schemas/3p-config";

interface isProductSmartlinkProps {
	productKey?: string; // loosely typed as string to accomodate for few cases which have this value as a string
	thirdPartyConfigs: ThirdPartyConfigsBootstrap;
}

export const isProductSmartlink = ({ productKey, thirdPartyConfigs }: isProductSmartlinkProps): boolean => {
	const product3PConfig =
		productKey && is3pProductKey(productKey) ? thirdPartyConfigs[productKey] : null;
	return (
		product3PConfig?.connectorSources?.length === 1 &&
		product3PConfig.connectorSources[0] === SMARTLINKS_CONNECTOR_SOURCE
	);
};